import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseStockSummary } from "./thunk";

interface DistrictState {
  WarehouseStockSummaryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  WarehouseStockSummaryList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "Inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseStockSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseStockSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.WarehouseStockSummaryList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehouseStockSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch WarehouseStockSummaryList";
      });
  },
});

export default inventorySlice.reducer;
